import React from "react";

import checkIcon from "../../Images/check-icon.svg";
import partyIcon from "../../Images/party-icon.svg";

export default function CounterRoundComplete({
  activeCounter,
  goalComplete,
  goalRoundKind,
  onStop,
  onContinue,
}) {
  if (!activeCounter) return null;

  // -------------------------
  // Derived values
  // -------------------------
  const isGoal = activeCounter.type === "goal";
  const isDaily = activeCounter.type === "daily";

  const isGoalFinal = isGoal && goalComplete;
  const isPerDayFlow = isDaily || (isGoal && !goalComplete);

  const plannedDays = activeCounter.days || 0;
  const distinctCalendarDays = Array.isArray(
    activeCounter.goalDistinctDates
  )
    ? activeCounter.goalDistinctDates.length
    : 0;

  const goalEarlyByDays =
    isGoalFinal && plannedDays > 0
      ? Math.max(0, plannedDays - distinctCalendarDays)
      : 0;

  const perBatch = activeCounter.perDayCount || 0;

  // -------------------------
  // Message builder
  // -------------------------
  const getMessage = () => {
    if (isGoalFinal) {
      return (
        <>
          <p>You have completed your goal!</p>

          {goalEarlyByDays > 0 && (
            <p>
              Wow — you reached your total in{" "}
              {distinctCalendarDays === 1
                ? "1 day"
                : `${distinctCalendarDays} different days`}
              , before your {plannedDays}-day plan. That is{" "}
              {goalEarlyByDays} day
              {goalEarlyByDays === 1 ? "" : "s"} ahead.
              Masha&apos;Allah!
            </p>
          )}
        </>
      );
    }

    if (isDaily) {
      return (
        <p>
          Current round is complete. Do you want to
          continue the count?
        </p>
      );
    }

    if (isGoal && !goalComplete) {
      if (goalRoundKind === "firstToday") {
        return (
          <p>
            Today&apos;s target is complete ({perBatch} count
            {perBatch === 1 ? "" : "s"}). Want to
            continue with another round of {perBatch}?
          </p>
        );
      }

      if (goalRoundKind === "extraToday") {
        return (
          <p>
            Another {perBatch}-count round is done for
            today. Keep going with the same size (
            {perBatch} per round) until you reach your
            goal?
          </p>
        );
      }

      return <p>Round complete. Continue?</p>;
    }

    return null;
  };

  // -------------------------
  // Handlers
  // -------------------------
  const handleStop = () => onStop?.();
  const handleContinue = () => onContinue?.();

  // -------------------------
  // Render
  // -------------------------
  return (
    <>
      {/* Overlay */}
      <div className="overlay" />

      {/* Modal */}
      <div
        className="modalWrapper show"
        role="dialog"
        aria-modal="true"
        aria-label="Round completion dialog"
      >
        {/* Header */}
        <div className="confirmText">
          <span className="confirmIcon">
            <img
              src={isGoalFinal ? partyIcon : checkIcon}
              alt=""
            />
          </span>
          {isGoalFinal ? "Congratulations" : "Completed"}
        </div>

        {/* Message */}
        {getMessage()}

        {/* Actions */}
        <div className="btnWrapper">
          {isPerDayFlow && (
            <>
              <button type="button" onClick={handleStop}>
                Stop it
              </button>

              <button
                type="button"
                className="confirm"
                onClick={handleContinue}
              >
                Sure
              </button>
            </>
          )}

          {isGoalFinal && (
            <button
              type="button"
              className="confirm"
              onClick={handleStop}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </>
  );
}